import { useState } from 'react';
import CharCounter from './CharCounter';

interface FormFieldProps {
  label: string;
  description?: string;
  defaultValue?: string;
  onChange: (value: string) => void;
  minChars?: number | null;
  maxChars?: number | null;
  maxScore?: number;
  isOptional?: boolean;
  placeholder?: string;
}

/**
 * Reusable labeled textarea with character counter and optional badge.
 * Manages its own display value; calls onChange on every keystroke (caller debounces).
 */
export default function FormField({
  label,
  description,
  defaultValue = '',
  onChange,
  minChars,
  maxChars,
  maxScore,
  isOptional,
  placeholder,
}: FormFieldProps) {
  const [value, setValue] = useState(defaultValue);

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 12, marginBottom: 6 }}>
        <h2 style={{ margin: 0, fontSize: 17, fontWeight: 700, color: 'var(--primary)' }}>{label}</h2>
        {maxScore != null && maxScore > 0 && (
          <span style={{ fontSize: 12, color: 'var(--muted-foreground)' }}>max {maxScore} pont</span>
        )}
        {isOptional && (
          <span style={{
            fontSize: 11, fontWeight: 700, padding: '2px 8px',
            borderRadius: 999, background: 'rgba(234,219,135,.35)', color: '#8a6500',
          }}>
            opcionális · plusz pont
          </span>
        )}
      </div>

      {description && (
        <p style={{ margin: '0 0 10px', fontSize: 13, color: 'var(--muted-foreground)', lineHeight: 1.55 }}>
          {description}
        </p>
      )}

      <textarea
        spellCheck={true}
        lang="hu"
        autoComplete="off"
        defaultValue={defaultValue}
        onChange={(e) => { setValue(e.target.value); onChange(e.target.value); }}
        placeholder={placeholder}
        minLength={minChars ?? undefined}
        maxLength={maxChars ?? undefined}
        style={{
          width: '100%', minHeight: 220, padding: '10px 12px',
          border: '1px solid var(--border)', borderRadius: 'var(--radius-sm)',
          fontSize: 14, fontFamily: 'var(--font-sans)', lineHeight: 1.6,
          resize: 'vertical', boxSizing: 'border-box',
        }}
      />
      <CharCounter current={value.length} min={minChars} max={maxChars} />
    </div>
  );
}
